import { render, staticRenderFns } from "./HomeWidget.vue?vue&type=template&id=5b6b9e72&"
import script from "./HomeWidget.vue?vue&type=script&lang=js&"
export * from "./HomeWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports